module.exports = __webpack_public_path__ + "static/firebase-icon-09dd4f018ced40d556883ec59a2e3a32.png";